import Services from './services'

export default function useJwt(axiosIns, jwtOverrideConfig) {
  const jwt = new Services(axiosIns, jwtOverrideConfig)

  return {
    jwt,
  }
}
